<template>
  <div>
    <NoData text="页面丢失了" path="/" :empty="empty" btnText="返回首页" />
    
  </div>
</template>

<script>
export default {
  data(){
    return {
      empty:require("@/assets/imgs/empty/404.png")
    }
  }
}
</script>

<style lang="less" scoped>

</style>